export default function ChinhSachBaoMat() {
  return (
    <div className="bg-white text-gray-800 py-12 px-4 md:px-8 lg:px-16 max-w-6xl mx-auto mt-16">
      <div className="text-center mb-10">
        <h1 className="text-3xl md:text-4xl font-bold text-pink-600 uppercase">
          Chính Sách Bảo Mật Thông Tin
        </h1>
        <p className="mt-4 text-gray-600 text-base md:text-lg">
          PT2000 cam kết bảo mật mọi thông tin cá nhân của khách hàng khi mua sắm trên hệ thống website và kênh bán hàng online.
        </p>
      </div>

      <div className="space-y-8 text-gray-700 leading-relaxed">
        <section>
          <h2 className="text-xl font-semibold mb-2 text-gray-900">1. Mục đích thu thập thông tin</h2>
          <ul className="list-disc pl-5">
            <li>Phục vụ việc xác nhận đơn hàng và giao hàng đến đúng địa chỉ.</li>
            <li>Liên hệ hỗ trợ khách hàng khi có sự cố phát sinh.</li>
            <li>Gửi thông tin khuyến mãi, ưu đãi và cập nhật sản phẩm mới (nếu được khách hàng đồng ý).</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-2 text-gray-900">2. Phạm vi thu thập thông tin</h2>
          <ul className="list-disc pl-5">
            <li>Họ tên, số điện thoại, email, địa chỉ giao hàng.</li>
            <li>Lịch sử đơn hàng, hành vi mua sắm và phản hồi.</li>
            <li>Thông tin tài khoản ngân hàng (nếu có thanh toán online).</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-2 text-gray-900">3. Thời gian lưu trữ</h2>
          <p>Thông tin cá nhân của khách hàng sẽ được lưu trữ cho đến khi có yêu cầu hủy bỏ hoặc khách hàng tự đăng nhập và thực hiện thao tác xóa. Trong mọi trường hợp, thông tin cá nhân sẽ được bảo mật trên máy chủ của PT2000.</p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-2 text-gray-900">4. Cam kết bảo mật</h2>
          <ul className="list-disc pl-5">
            <li>Không chia sẻ, bán hoặc cho thuê thông tin khách hàng cho bên thứ ba.</li>
            <li>Sử dụng các biện pháp bảo mật tiêu chuẩn ngành để bảo vệ dữ liệu cá nhân.</li>
            <li>Chỉ tiết lộ thông tin trong trường hợp pháp luật yêu cầu.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-2 text-gray-900">5. Quyền của khách hàng</h2>
          <ul className="list-disc pl-5">
            <li>Kiểm tra, cập nhật, điều chỉnh thông tin cá nhân bất kỳ lúc nào.</li>
            <li>Yêu cầu PT2000 ngừng sử dụng hoặc xóa thông tin cá nhân của bạn.</li>
            <li>Rút lại sự đồng ý nhận email marketing bất cứ lúc nào.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-2 text-gray-900">6. Thông tin liên hệ</h2>
          <p>
            Mọi thắc mắc hoặc yêu cầu liên quan đến chính sách bảo mật, vui lòng liên hệ:
          </p>
          <ul className="mt-2 list-disc pl-5">
            <li>Hotline: <strong>0784 992 000</strong></li>
           
            <li>Địa chỉ: 153AB Nam Kỳ Khởi Nghĩa, Phường Võ Thị Sáu, Quận 3, TP.HCM</li>
          </ul>
        </section>
      </div>

      <div className="mt-12 text-center border-t pt-6">
        <p className="text-gray-700">
          PT2000 trân trọng sự tin tưởng của khách hàng và cam kết bảo vệ dữ liệu của bạn với sự cẩn trọng cao nhất.
        </p>
      </div>
    </div>
  );
}
